<template>
    <div class="form">
        <div class="form__row-between">
            <div class="regions">
                <licSearchSelect
                    :obj="regionsObj"
                    :keys="regionsKeys"
                    :required="true"
                    :label="'Регионы'"
                    :value="region"
                    v-model="region"
                />
            </div>
            <label class="city">
                Населенный пункт <span id="asterics">&#42;</span> <br>
                <input v-model="city" placeholder="Населенный пункт" autocomplete="off" type="text">
            </label>
        </div>
        <div class="form__row-between">
            <label class="street">
                Улица <span id="asterics">&#42;</span> <br>
                <input v-model="street" placeholder="Улица" autocomplete="off" type="text">
            </label>
            <div class="build-container">
                <label class="house">
                    Дом <span id="asterics">&#42;</span> <br>
                    <input v-model="house" placeholder="Дом" autocomplete="off" type="text">
                </label>
                <label class="building">
                    Корпус <br>
                    <input v-model="build" placeholder="Корпус" autocomplete="off" type="text">
                </label>
                <label class="flat">
                    Квартира/Офис <br>
                    <input v-model="flat" placeholder="Квартира/Офис" autocomplete="off" type="text">
                </label>
            </div>
        </div>
        <div class="form__row-end">
            <div class="buttons_container">
                <button @click="clearForm" class="clear_btn">Очитстить</button>
                <button @click="checkAddress" class="submit_btn" :class="{ 'disabled_btn': !isValidForm }" :disabled="!isValidForm">
                    <i v-if="loading" class="lnr lnr-sync rotating" title="Загрузка" style="font-size: 18px; display: inline-block;"></i>
                    <span v-else>Поиск</span>
                </button>
            </div>
        </div>
        <div class="form_row-start">
            <p class="limits" v-if="limits">Использовано запросов: {{limits.used_total}}<span v-if="limits.total"> из {{limits.total}}</span></p>
            <p><span id="asterics">&#42;</span> - поля обязательные к заполнению</p>
        </div>
    </div>
</template>

<script>
import licSearchSelect from '@/components/ui/licSearchSelect/licSearchSelect.vue'

export default {
    components: { licSearchSelect },
    computed: {
        loading() { return this.$store.state?.addressCheck?.isAddressLoading },
        isValidForm() { return this.$store.getters['addressCheck/isValidForm']},
        regionsObj() { return this.$store.state?.addressCheck?.regions },
        regionsKeys() { return this.$store?.getters['addressCheck/regionsKeys'] },
        formData() { return this.$store?.state?.addressCheck?.formData },
        limits() { return this.$store.state.user?.limits?.filter(e => e.id == 112)[0] },
        region: {
            get() { return this.$store.state.addressCheck.formData.region },
            set(value) { this.$store.commit('addressCheck/setDataValue', { key: 'region', value })}
        },
        city: {
            get() { return this.$store.state.addressCheck.formData.city },
            set(value) { this.$store.commit('addressCheck/setDataValue', { key: 'city', value }) }
        },
        street: {
            get() { return this.$store.state.addressCheck.formData.street },
            set(value) { this.$store.commit('addressCheck/setDataValue', { key: 'street', value }) }
        },
        house: {
            get() { return this.$store.state.addressCheck.formData.house },
            set(value) { this.$store.commit('addressCheck/setDataValue', { key: 'house', value }) }
        },
        build: {
            get() { return this.$store.state.addressCheck.formData.building },
            set(value) { this.$store.commit('addressCheck/setDataValue', { key: 'build', value }) }
        },
        flat: {
            get() { return this.$store.state.addressCheck.formData.flat },
            set(value) { this.$store.commit('addressCheck/setDataValue', { key: 'flat', value }) }
        }
    },
    methods: {
        checkAddress() {
            this.$store.commit('addressCheck/changeLoading', true) 
            this.$store.dispatch('addressCheck/checkAddress', this.formData) 
        },
        clearForm() { this.$store.commit('addressCheck/clearData') }
    },
    mounted() { this.$store.dispatch('addressCheck/getRegions') }
}
</script>

<style lang="sass" scoped>
    @mixin form-row
        width: 100%
        display: flex
        gap: 15px

    input, select
        display: block
        width: 100%
        min-height: 30px
        border-radius: 3px
        padding: 4px 8px
        border: 1px solid #b8b8b8
        box-shadow: none
        text-align: left
        margin-top: 5px
    label
        font-weight: 400
        font-size: 14px
    p
        font-weight: 400
        font-size: 12px
    .form
        max-width: 676px
        width: 100%
        display: flex
        flex-direction: column
        gap: 15px
        padding-top: 50px
        &__row-between
            @include form-row
            justify-content: space-between
        &__row-end
            @include form-row
            justify-content: flex-end
        &__row-start  
            @include form-row  
            justify-content: flex-start
    .regions
        width: 55%
    .city
        width: 55%
    .street
        width: 50%
    .build-container
        width: 50%
        display: flex
        flex-direction: row
        gap: 15px
        .house, .building
            width: 33.333%
            text-overflow: ellipsis
        .flat
            display: inline-block
            max-width: 38.333%
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
            input
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
    .clear_btn
        display: inline-block
        vertical-align: top
        width: 112px
        height: 34px
        text-align: center
        line-height: 34px
        font-weight: 500
        font-size: 14px
        border: 0
        border-radius: 5px
        cursor: pointer
        color: #333
        background-color: transparent
        &:active
            color: #484747
            background-color: #a7baf9
    .submit_btn
        display: inline-block
        vertical-align: top
        width: 112px
        height: 34px
        text-align: center
        line-height: 34px
        color: #fff
        font-weight: 500
        font-size: 14px
        background-color: #4771f3
        border: 0
        border-radius: 5px
        cursor: pointer
        &:active
            color: #484747
            background-color: #a7baf9
    .disabled_btn
        opacity: 0.5
        cursor: not-allowed
    #asterics
        color: #4771f3
        font-size: 13px
    .limits
        font-size: 14px
</style>